export class ReplaceInsuranceError extends Error {
  constructor() {
    super('Replace insurance');
  }
}
